import Background from 'assets/btn-btg.svg';

const ButtonChakra = {
  baseStyle: {},
  sizes: {},
  variants: {
    primary: {
      bg: '#0092b0',
      color: 'white',
      _hover: {
        filter: 'grayscale(1)',
      },
      _active: {
        filter: 'grayscale(1)',
      },
      _disabled: {
        bg: '#0092b0 !important',
        cursor: 'not-allowed',
        opacity: 0.6,
        backgroundImage: `url('${Background}') !important`,
        backgroundRepeat: 'no-repeat !important',
        filter: 'unset !important',
      },
      fontWeight: 700,
      minWidth: '165px',
      maxWidth: '250px',
      height: '60px',
      fontSize: '16px',
      borderRadius: 'unset',
      backgroundImage: `url('${Background}')`,
      backgroundRepeat: 'no-repeat',
    },
  },
  defaultProps: {},
};

export default ButtonChakra;
